/**
 * Search performance report endpoints (sbend). v3 = cron SearchKeyAnalyticsV3 output indices.
 * @see sbend api/Routes/analytics.js — /api/v3/analytics
 */
export const SEARCH_REPORTS_ANALYTICS_API_BASE = "api/v3/analytics";
export const SEARCH_ZERO_REPORTS_ANALYTICS_API_BASE = "api/v4/analytics";

/** @param {string} segment e.g. "searchFunnel" */
export const searchReportsAnalyticsUrl = (segment) =>
  `${SEARCH_REPORTS_ANALYTICS_API_BASE}/${segment}`;

/** @param {string} segment e.g. "searchFunnel" */
export const searchZeroReportsAnalyticsUrl = (segment) =>
  `${SEARCH_ZERO_REPORTS_ANALYTICS_API_BASE}/${segment}`;
